
const RESERVED_CUSTOM_CODES = [
    'relation',
    'investor',
    'investor-relation',
    'pricing',
    'token',
    'pages',
    'contact',
    'people',
    'management',
    'event',
    'check',
    'career',
    'press',
    'about',
    'terms',
    'register',
    'admin',
    'setting',
    'profile',
    'account',
    'legal',
    'security',
    'status',
    'feature',
    'static',
    'public',
    'internal',
    'error',
    'undefined',
    'false',
    'brand',
    'branded',
    'company',
    'promo',
    'marketing',
    'analytic',
    'redirect',
    'reserved',
    'shodl',
    'shodl.io',
    'shortl',
    'reset',
    'password',
    'shared',
    'shortening',
    'conversion',
    'combined',
    'review',
    'partner',
    'accessibility',
    'compliance',
    'mobile',
    'extension',
    'integration',
    'transparency',
    'policy',
    'policies',
    'code-of-conduct',
    'code-conduct',
    'browser-extension',
    'developer',
    'resource',
    'trust',
    'url-shortener',
    'shortener',
    'generator',
    'qr-code',
    'link-in-bio',
    'branded-link',
    'solution',
    'enterprise',
    'mobile-link',
    'utm-link',
    'combined-link',
    'group',
    'group-link',
    'digital-business-card',
    'acceptable-use',
    'acceptable-usage',
    'cookie',
    'terms-of-service',
    'transparency-report',
    'mobile-app',
    'marketplace',
    'notify',
    'notification',
    'confirmation',
    'viewportization',
    'operation',
    'gallery',
    'link-panel',
    'panel',
    'campaign',
    'composition',
    'login',
    'logout',
    'signin',
    'signout',
    'signup',
    'oauth',
    'authentication',
    'authorization',
    'token-refresh',
    'refresh',
    'webhook',
    'callback',
    'server',
    'asset',
    'robots.txt',
    'robot',
    'sitemap.xml',
    'sitemap',
    'favicon.ico',
    'favicon',
    'manifest.json',
    'manifest',
    'health',
    'uptime',
    'dashboard',
    'audit',
    'admin-panel',
    'user',
    'role',
    'permission',
    'subscription',
    'billing',
    'payment',
    'plan',
    'stat',
    'metric',
    'track',
    'tracking',
    'click',
    'traffic',
    'view',
    'performance',
    'support',
    'feedback',
    'report',
    'issue',
    'ticket',
    'request',
    'automation',
    'autoresponder',
    'prompt',
    'chatbot',
    'assistant',
    'copilot',
    'recommendation',
    'index',
    'default',
    'sandbox',
    'preview',
    'stage',
    'staging',
    'prod',
    'production',
    'google',
    'youtube',
    'twitter',
    'linkedin',
    'facebook',
    'instagram',
    'openai',
    'apple',
    'amazon',
    'microsoft',
    'delete',
    'remove',
    'destroy',
    'demolish',
    'malware',
    'phish',
    'adult',
    'casino',
    'bitcoin',
    'crypto',
    'viagra',
    'smart',
    'smartcode',
    'autocode',
    'custom',
    'customcode',
    'dictcode',
    'verify',
    'hook',
    'search',
    'explore',   
    'invite',      
    'username',
    'termsandconditions',
    'privacypolicy', 
    'start',            
    'onboarding',    
    'gettingstarted',    
    'newsroom',      
    'media',       
    'brandkit',   
    'webapp',   
    'previewlink',   
    'unsubscribe',  
    'download',      
    'upload',      
    'uploads-public', 
    'public',
    'font',           
    'nullify',  
    'access',     
    'author',    
    'publisher', 
    'host',
    'dnslookup',  
    'whoami',    
    'ping',          
    'testserver',   
    'convert',     
    'expire',       
    'clone',
    'archive',  
    'dbadmin',     
    'sqlpanel',   
    'openredirect', 
    'securelink',    
    'google-auth',   
    'facebook-auth',     
    'inbox',    
    'thread',      
    'reel',      
    'short',
    'route',
    'slice',
    'theme',
    'ignore',
    'router',
    'not-found',
    'empty',
    'alias',    
    'session',    
    'api-docs',     
    'shortlink',    
    'assets',   
    'settings',      
    'me-settings',
    'shorturl',    
    'email-confirmation',
    'invite-code',    
    'referral',       
    'maintenance',    
    'disable',       
    'blocked',     
    'scan',         
    'pdf-export',   
    'claim',      
    'validate',     
    'authorize',     
    'recover',     
    'secure',         
    'login-confirm',  
    'identity',      
    'confirm-email',  
    'reset-password',
    '.well-known',    
    'node_modules',  
    '.env',         
    'environment',   
    'server-status',   
    'metrics-endpoint',
    'user-setting',
    'my-profile',
    'my-account',
    'identity',
    'verify-email',
    'resend-confirmation',
    'endpoint',
    'metrics-endpoint',
    'opengraph',
    'og-image',
    'analytics-script',
    'script',
    'claim',
    'reward',
    'bonus',
    'validate',
    'redeem',
    'secure-login',
    'free-gift',
    'gift',
    'free',
    'unlock',
    'confirm-account',
    'redirect-url',
    'forward',
    'jump',
    'next',
    'previous',
    'test',
    'local',
    'local-dev',
    'localhost',
    'beta',
    'alpha',
    'debug',
    'terms-and-conditions',
    'privacy-policy',
    'cookie-policy',
    'eula',
    'ccpa',
    'gdpr',
    'support-center',
    'helpdesk',
    'desk',
    'help',
    'abuse',
    'filter',
];

export default RESERVED_CUSTOM_CODES;